module.exports = __webpack_public_path__ + "img/Background_empty.f086d3ed.png";